import type { Pages } from "@hireroo/presentation";

export type GenerateMonacoEditorPlaygroundPropsArgs = {};

export const useGenerateProps = (_args: GenerateMonacoEditorPlaygroundPropsArgs): Pages.MonacoEditorPlaygroundProps => {
  return {};
};
